import { useEffect, useState } from 'react';
import moment from 'moment';

const useCountdown = targetDate => {
  const countDownDate = moment(targetDate).unix();

  const [countDown, setCountDown] = useState(countDownDate - moment(new Date()).unix());

  useEffect(() => {
    const interval = setInterval(() => {
      setCountDown(countDownDate - moment(new Date()).unix());
    }, 1000);

    return () => clearInterval(interval);
  }, [countDownDate]);

  return getReturnValues(moment(countDown * 1000));
};

const getReturnValues = countDown => {
  const days = Math.floor(countDown / (1000 * 60 * 60 * 24));
  const hours = Math.floor((countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((countDown % (1000 * 60)) / 1000);

  return [days, hours, minutes, seconds];
};

export { useCountdown };
